import axios from 'axios'
import {BASE_URL} from '../config'

export interface IOverviewCount {
  awatting: number
  open: number
  Reply: number
  total: number
}

export interface ITicketCreate {
  ticketMessage: string
  mailTo: string
  mailToCC: string
  ticketSubject: string
  isAttachment: string
  attachment: string[]
}

export interface ITicket {
  id: number
  subject: string
  user_name: string
  created_at: string
  status: string
  assignedTo?: string
}

export interface ITicketAssignFormValues {
  username: string
  userId: number | null
}

export interface ITicketDetails {
  id: number
  attachments: string[] | null
  mail_to: string
  user_name: string
  subject: string
  queryMessage: string
  mail_to_cc: string
  status: string
}

export interface IReplyTicketValues {
  ticketMessage: string
  isAttachment: string
  attachment: string[]
}

export interface ITicketQueryDetails {
  queryAttachment: string[]
  mailTocc: string
  user_name: string
  subject: string
  created_at: string
  mailto: string
  queryMessage: string
  assignedTo: string
  status: string
  replyTo?: {
    replyTime: string
    ticket: number
    replyMessage: string
    replyUserName: string
    replyAttachments: string[]
  }
}

export const initTicketCreateValues: ITicketCreate = {
  ticketMessage: '',
  mailTo: '',
  mailToCC: '',
  ticketSubject: '',
  isAttachment: '0',
  attachment: [],
}

export const initTicketAssignFormValues: ITicketAssignFormValues = {
  username: '',
  userId: null,
}

export const initReplyTicketFormValues: IReplyTicketValues = {
  ticketMessage: '',
  isAttachment: '0',
  attachment: [],
}

export interface ITicketDetailsResponse {
  mail_to: string
  user_name: string
  subject: string
  mail_to_cc: string
  status: string
  assignedTo?: string
  userId: number
  assignedToId: number
}

export interface ITicketQueryReplyResponse {
  data: {
    rid: string
    user: string
    message: string
    ticket: number
    time: string
    isquery: 0 | 1
    attach?: string[]
  }[]
}

export type ISendReplyValuesType = {
  ticketMessage: string
  isAttachment: '0' | '1'
}

export type TicketReplyType = {
  ticketMessage: string
  attachment: []
}

const GET_TICKET_DETAILS_ID_URL = `${BASE_URL}/api/protect/getTicketDetailsById?ticketId=`

export const getTicketDetailsById = async (id: number): Promise<ITicketDetails> => {
  const response = await axios.get(`${GET_TICKET_DETAILS_ID_URL}${id}`)
  return response.data
}
